import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import BasicContent from '@/components/structure/BasicContent';
export const Card = ({ card: { img, alt, title, description, link, onPress }, }) => {
    return (_jsxs(Box, { backgroundColor: "color.border.constant.white", borderRadius: "radius.16", paddingVertical: "spacing.24", paddingHorizontal: "spacing.32", flex: {
            'breakpoint.base': '0 0 270px',
            'breakpoint.md': '1 0 290px',
            'breakpoint.lg': '0 0 427px',
        }, display: "flex", flexDirection: "column", children: [_jsx(Box, { as: "img", alt: alt, src: img, width: 197, marginHorizontal: "auto", display: "block", marginBottom: "spacing.32" }), _jsx(BasicContent, { title: title, titleAs: "h2", description: description, link: link, size: "small", onPress: onPress })] }));
};
